<template>
  <div>
    <div class="view pa24 mr mb20">
      <span style="color: #8d97ad; font-size: 14px"
        >{{ $t('merchandise', 'publishProcess') }}</span
      >
    </div>

    <el-form
      ref="form" :model="form" :rules="rules" label-width="auto" class="view pa24" label-position="left"
    >
      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'selectGoodsType') }}</p>
      <el-form-item prop="goodstypeId" :label="$t('merchandise', 'goodsCategory')">
        <el-select v-model="form.goodstypeId" :placeholder="$t('merchandise', 'pleaseSelectGoodsType')">
          <el-option
            v-for="(item, index) in goodsType"
            :key="index"
            :label="item.name"
            :value="item.goodstypeId"
          />
        </el-select>
        <el-button type="primary" class="ma ml10" @click="open"
          >{{ $t('merchandise', 'addCategory') }}</el-button
        >
      </el-form-item>
      <hr
        style="
          background-color: #e4e4e4;
          border: none;
          height: 1px;
          margin: 20px 0;
        "
      />
      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'inputGoodsBasicInfo') }}</p>
      <el-form-item prop="goodsName" :label="$t('merchandise', 'goodsTitle')">
        <el-input
          v-model="form.goodsName"
          style="width: 350px"
          :placeholder="$t('merchandise', 'pleaseEnterGoodsName')"
          maxlength="30"
          show-word-limit
        ></el-input>
      </el-form-item>

      <el-form-item prop="stockNum" :label="$t('merchandise', 'goodsStock')">
        <el-input
          v-model="form.stockNum"
          oninput="value=value.replace(/[^\d]/g,'')"
          type="number"
          style="width: 350px"
          :placeholder="$t('merchandise', 'pleaseEnterGoodsStock')"
          show-word-limit
          maxlength="10"
        ></el-input>
      </el-form-item>

      <el-form-item prop="goodSpecModelList" :label="$t('merchandise', 'goodsSpecification')">
        <el-alert
          v-if="isResaleGoods"
          :title="$t('merchandise', 'resaleGoodsSpecTip')"
          type="warning"
          :closable="false"
          style="margin-bottom: 10px; width: 550px;">
        </el-alert>
        <div
          style="
            border: 1px solid #e4e4e4;
            width: 550px;
            border-radius: 5px;
            padding: 10px 20px;
          "
          ref="addEl"
        >
          <div
            v-for="(item, index) in form.goodSpecRequestList ||
            form.goodSpecModelList"
            :key="index"
            style="margin-top: 10px"
          >

              <el-input
                type="text"
                :placeholder="$t('merchandise', 'pleaseEnterGoodsTypeName')"
                v-model="item.specName"
                style="width: 380px"
                :disabled="isResaleGoods"
              /><span 
                v-if="!isResaleGoods"
                class="hover_pointer"
                @click="deleteName(index)"
                style="color: #51cdcb; margin-left: 5px"
                >{{ $t('merchandise', 'delete') }}</span>
              <span style="margin-left: 5px;">
               <el-switch
                       v-model="item.requiredSelect"
                       :active-text="$t('merchandise', 'required')"
                       inactive-text=""
                       :disabled="isResaleGoods">
                </el-switch>
              </span>
              <div
                v-for="(attr, index1) in item.list || item.goodSpecModelList"
                :key="index1"
                style="margin-top: 5px"
              >
                  <el-input
                    type="text"
                    :placeholder="$t('merchandise', 'pleaseEnterGoodsSpecification')"
                    v-model="attr.specAttribute"
                    style="width: 180px"
                    @blur="specAttribute =  attr.specAttribute"
                    :disabled="isResaleGoods"
                  />
                  <div style="margin-top: 5px;">
                    <div style="margin-bottom: 5px;">
                      <span style="font-size: 12px; color: #666; margin-right: 5px;">{{ $t('merchandise', 'price') }}:</span>
                      <el-input
                        v-model="attr.price"
                        type="number"
                        :placeholder="$t('merchandise', 'pleaseEnterPrice')"
                        style="width: 120px"
                        @change="() => {
                          attr.price =  attr.price < 0.01 ? '' : (attr.price*1).toFixed(2)
                        }"
                      />
                    </div>
                    <div>
                      <span style="font-size: 12px; color: #666; margin-right: 5px;">{{ $t('merchandise', 'wholesalePrice') }}:</span>
                      <el-input
                        v-model="attr.wholesalePrice"
                        type="number"
                        :placeholder="$t('merchandise', 'wholesalePrice')"
                        style="width: 120px"
                        @change="() => {
                          attr.wholesalePrice =  attr.wholesalePrice < 0.01 ? '' : (attr.wholesalePrice*1).toFixed(2)
                        }"
                      />
                    </div>
                  </div>
                  <span 
                    v-if="!isResaleGoods"
                    class="hover_pointer"
                    @click="deleteAttribute(index, index1)"
                    style="color: #51cdcb; margin-left: 5px; margin-right: 5px"
                    >{{ $t('merchandise', 'delete') }}</span
                  ><span 
                    v-if="!isResaleGoods"
                    class="hover_pointer" 
                    @click="addAttribute(index)" 
                    style="color: #51cdcb"
                    >{{ $t('merchandise', 'addAttribute') }}</span
                  >
              </div>
          </div>
          <span 
            v-if="!isResaleGoods"
            class="hover_pointer" 
            @click="addSpec()" 
            style="color: #51cdcb; margin-top: 10px">
            {{ $t('merchandise', 'addSpecification') }}
          </span>
        </div>
      </el-form-item>

      <el-form-item prop="goodPhoto" :label="$t('merchandise', 'goodsImage')">
        <p class="ma mb10" style="color: rgb(150, 150, 150)">
          {{ $t('merchandise', 'uploadImageTip') }}
        </p>
        <div style="display: flex">
          <el-upload
            :action="uploadUrl"
            :class="{
              disabled: uploadDisabled,
            }"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :on-success="goodsUpload"
            :file-list="form.goodPhoto"
            :limit="5"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            :modal-append-to-body="false"
          >
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </el-form-item>
      <hr
        style="
          background-color: #e4e4e4;
          border: none;
          height: 1px;
          margin: 20px 0;
        "
      />
      <el-form-item prop="coverImg" :label="$t('merchandise', 'shareImage')">
        <p class="ma mb10" style="color: rgb(150, 150, 150)">
          {{ $t('merchandise', 'shareImageTip') }}
        </p>
        <div>
          <el-upload
            :action="uploadUrl"
            :class="{
              disabled: uploadDisabled2,
            }"
            list-type="picture-card"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove2"
            :on-success="shareUpload"
            :file-list="form.coverImg"
            :limit="1"
          >
            <i class="el-icon-plus"></i>
          </el-upload>
          <el-dialog
            :visible.sync="dialogVisible"
            append-to-body
            :modal-append-to-body="false"
          >
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
      </el-form-item>
      <hr
        style="
          background-color: #e4e4e4;
          border: none;
          height: 1px;
          margin: 20px 0;
        "
      />
      <el-form-item :label="$t('merchandise', 'isDistribution')"  label-width="130px" v-if="!isProduction">
        <el-radio-group v-model="form.isDistribution">
          <el-radio :label="1">{{ $t('common', 'yes') }}</el-radio>
          <el-radio :label="0">{{ $t('common', 'no') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item :label="$t('merchandise', 'isShowDistributionText')"  label-width="130px" v-if="form.isDistribution && !isProduction">
        <el-radio-group v-model="form.isHiddenTitle">
          <el-radio :label="0">{{ $t('common', 'yes') }}</el-radio>
          <el-radio :label="1">{{ $t('common', 'no') }}</el-radio>
        </el-radio-group>
      </el-form-item>
    
      <el-form-item :label="$t('merchandise', 'isPublishToProductCenter')"  v-if="!isProduction" label-width="150px">
        <el-radio-group v-model="form.isPublic">
          <el-radio :label="true">{{ $t('common', 'yes') }}</el-radio>
          <el-radio :label="false">{{ $t('common', 'no') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'paymentMethod') }}</p>
      <el-form-item :label="$t('merchandise', 'paymentMethod')">
        <el-radio-group v-model="form.ispayment">
          <el-radio :label="1" v-if="!isProduction">{{ $t('merchandise', 'onlinePayment') }}</el-radio>
          <el-radio :label="2">{{ $t('merchandise', 'creditPayment') }}</el-radio>
          <el-radio :label="3">{{ $t('merchandise', 'other') }}</el-radio>
        </el-radio-group>
      </el-form-item>

      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'inputGoodsDetails') }}</p>
      <el-form-item label-width="0px">
        <p class="ma mb10">{{ $t('merchandise', 'goodsDetails') }}</p>
        <!-- //富文本 -->
        <quill-editor
          style="height: 100%"
          v-model="form.goodsDetails"
          ref="myQuillEditor"
          :options="editorOption"
          @ready="onEditorReady($event)"
        />
      </el-form-item>

      <el-form-item label-width="0px">
        <el-button
          type="primary"
          size="medium"
          @click="addGood"
          >{{ $t('merchandise', 'publish') }}</el-button
        >

        <el-button size="medium" @click="isShow = true">{{ $t('merchandise', 'preview') }}</el-button>
      </el-form-item>
      <prevGoods :isShow="isShow"
                :prod_imgs="form.goodPhoto"
                :prod-size="form.goodSpecRequestList || form.goodSpecModelList"
                :edit_html="form.goodsDetails"
                @close="prodClose"
              ></prevGoods>
    </el-form>
  </div>
</template>

<script>
// @ts-ignore
import {
  getGoodsTypeInfo,
  addGoodsType,
  getGoodsInfo,
  addGoods,
} from "@/api/coupon.js";
import prevGoods from './components/prevGoods'
import { quillEditor, Quill } from "vue-quill-editor"; //
import resizeImage from "quill-image-resize-module"; // 调整大小组件。
import { ImageDrop } from "quill-image-drop-module"; // 拖动加载图片组件
import quillConfig from "@/utils/quill-config.js";
import i18nMixin from '@/mixins/i18nMixin';
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/resizeImage ", resizeImage);
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { isProduction } from '@/utils';
quillConfig.placeholder = '请填写商品详情'

export default {
  mixins: [i18nMixin],
  data() {
    var validatePass2 = (rule, value, callback) => {
      console.log(this.form)
      if ((this.form.goodSpecModelList && this.form.goodSpecModelList.length > 0 && this.form.goodSpecModelList[0]) ||  
          (this.form.goodSpecRequestList && this.form.goodSpecRequestList.length > 0 && this.form.goodSpecRequestList[0])  ) {
        callback();
      } else {
        callback(new Error(this.$t('merchandise', 'pleaseCompleteGoodsSpecification')));
      }
    };
    var valiGoodPhoto = (rule, value, callback) => { // 图片验证
      if (this.form.goodPhoto.length == 0) {
        callback();
      } else {
        callback();
      }
    };
    var valiCoverImg = (rule, value, callback) => { // 图片验证
      if (this.form.coverImg.length == 0) {
        callback();
      } else {
        callback();
      }
    };
    return {
      editorOption: quillConfig,
      isShow: false,
      form: {
        goodsName: "", //商品名称
        stockNum: "", //库存
        goodstypeId: "", //类型ID
        goodsDetails: "", //商品详情
        ispayment: 2, //支付方式
        isDistribution: 0, //分销售
        isPublic: false, //上架
        goodPhoto: [], //商品图片
        coverImg: [],
        isHiddenTitle: 0,
        //商品规格
        specAttribute:'',
        goodSpecRequestList: [
          {
            specName: "", //规格名称
            list: [
              {
                specAttribute: "", //规格属性（价格）
                specNum: "1", //规格数量
                price: '', //零售价除100
                wholesalePrice: '', //批发价除100
                requiredSelect:false
              },
            ],
          },
        ],
        goodSpecModelList:[],
      },
      rules: {
        goodstypeId: [{ required: true, message: this.$t('merchandise', 'pleaseSelectCategory') }],
        goodsName: [
          {
            required: true,
            message: this.$t('merchandise', 'pleaseEnterProductTitle'),
            trigger: "change",
          },
        ],
        stockNum: [{ required: true, message: this.$t('merchandise', 'pleaseEnterStock'), trigger: "change"}
        ],
        goodSpecModelList: [{ required: true, validator: validatePass2 , trigger: "change" }],
        goodsDetails: [
          { required: true, message: this.$t('merchandise', 'pleaseEnterDescription'), trigger: "change" },
        ],
        goodPhoto: [{ required: true, validator: valiGoodPhoto, trigger: "change"  }],
        coverImg: [{ required: true, validator: valiCoverImg , trigger: "change" }],
      },
      goodsType: [], //分类渲染
      uploadUrl: this.$store.state.uploadingUrl,
      ossUrl: this.$store.state.ossUrl,
      dialogImageUrl: "",
      dialogVisible: false,
      indexs: "",
    };

  },
  components: {
    prevGoods,
    quillEditor
  },
  computed: {
    uploadDisabled() {
      return this.form.goodPhoto.length >= 5;
    },
    uploadDisabled2() {
      return this.form.coverImg && this.form.coverImg.length >= 1;
    },
    isProduction() {
      return isProduction();
    },
    // 判断是否为跟卖商品
    isResaleGoods() {
      return !!(this.form.resaleLevel && this.form.resaleLevel > 0);
    }
  },
  async created() {
    // 生产环境强制关闭分销功能
    if (isProduction()) {
      this.form.isDistribution = 0;
    }
    
    this.goodsId = this.$route.query.id;
    if (this.$route.query.id) {
      const result = await getGoodsInfo({ goodsId: this.$route.query.id });

      let results = JSON.parse(result.data.pageInfo).list[0];
       console.log(results)
      if (results.goodPhoto ) {
        results.goodPhoto = results.goodPhoto.split(",").map((item, index) => {
          return {
            url: item,
            uid: index,
          };
        });
      }
      if (results.coverImg && results.coverImg.length !== 2 && results.coverImg.length !== 0) {
        results.coverImg = [{ url: results.coverImg, uid: 1 }];
      } else {
        results.coverImg = [];
      }
      this.form = results;
      
      // 生产环境强制关闭分销功能
      if (isProduction()) {
        this.form.isDistribution = 0;
      }
      this.form.goodSpecModelList.forEach((val, k) => {
        for (var i in val.goodSpecModelList) {
          val.goodSpecModelList[i].price = (val.goodSpecModelList[i].price / 100).toFixed(2);
          val.goodSpecModelList[i].wholesalePrice = val.goodSpecModelList[i].wholesalePrice ? (val.goodSpecModelList[i].wholesalePrice / 100).toFixed(2) : '';
          this.specAttribute =  val.goodSpecModelList[i].specAttribute
          console.log(this.specAttribute)
        }
      });
    }
    const datas = await getGoodsTypeInfo({});
    this.goodsType = datas.data;
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    async getGoodsInfo() {},
    delImg(index) {
      this.form.goodPhoto.splice(index, 1);
    },

    open1() {
      this.$alert(
        `
      <div style="color:red">
          <div>
      </div>`,
        {
          dangerouslyUseHTMLString: true,
          // showClose: false,
          showonConfirmButton: true,
          distinguishCancelAndClose: false,
        }
      );
    },

    addSpec: function () {
      if (!this.$route.query.id) {
        this.form.goodSpecRequestList.push({
          specName: "",
          list: [
            {
              specAttribute: "",
              specNum: 1,
              price: 0,
              wholesalePrice: 0,
            },
          ],
        });
      } else {
        this.form.goodSpecModelList.push({
          specName: "",
          goodSpecModelList: [
            {
              specAttribute: "",
              specNum: 1,
              price: 0,
              wholesalePrice: 0,
            },
          ],
        });
      }
    },

    deleteAttribute: function (index, index1) {
      if (!this.$route.query.id) {
        this.form.goodSpecRequestList[index].list.splice(index1, 1);
      } else {
        this.form.goodSpecModelList[index].goodSpecModelList.splice(index1, 1);
      }
    },

    deleteName: function (index) {
      if (!this.$route.query.id) {
        this.form.goodSpecRequestList.splice(index, 1);
      } else {
        this.form.goodSpecModelList.splice(index, 1);
      }
    },

    addAttribute: function (index) {
      if (!this.$route.query.id) {
        this.form.goodSpecRequestList[index].list.push({
          specAttribute: "",
          specNum: 1,
          price: 0,
        });
      } else {
        this.form.goodSpecModelList[index].goodSpecModelList.push({
          specAttribute: "",
          specNum: 1,
          price: 0,
        });
      }
    },

    onSubmit() {
      console.log("submit!");
    },

    handleRemove(file, fileList) {
      this.form.goodPhoto = fileList;
    },
    handleRemove2(file, fileList) {
      this.form.coverImg = fileList;
    },
    //新增商品
    addGood() {
      if(this.form.goodPhoto.length == 0){
        return this.$message({
          message: this.$t('merchandise', 'goodsImageNotUploaded'),
          type: "warning",
          center: true,
        });
      }
      if(this.form.coverImg.length == 0){
        return this.$message({
          message: this.$t('merchandise', 'shareImageNotUploaded'),
          type: "warning",
          center: true,
        });
      }
      let err = ''
      this.$refs.form.validate(async (valid) => {
        if (valid) {
        if(this.form.goodSpecRequestList){
          this.form.goodSpecRequestList.forEach((val, k) => {
            if(!val.specName){
              err = true
              return
            }
            for (var i in val.list) {
              if(!val.list[i].price || !val.list[i].specAttribute){
                err = true
                break
              }
              // 处理价格：字符串转换为数字（分）
              const priceStr = String(val.list[i].price);
              val.list[i].price = Number(priceStr.replace(".", ""));
              // 处理批发价：字符串转换为数字（分）
              if (val.list[i].wholesalePrice) {
                const wholesalePriceStr = String(val.list[i].wholesalePrice);
                val.list[i].wholesalePrice = Number(wholesalePriceStr.replace(".", ""));
              }
            }
          });
        }else{
            this.form.goodSpecModelList.forEach((val, k) => {
              for (var i in val.goodSpecModelList) {
                if(!val.goodSpecModelList[i].price || !val.goodSpecModelList[i].specAttribute){
                  err = true
                  break
                }
                // 处理价格：字符串转换为数字（分）
                const priceStr = String(val.goodSpecModelList[i].price);
                val.goodSpecModelList[i].price = Number(priceStr.replace(".", ""));
                // 处理批发价：字符串转换为数字（分）
                if (val.goodSpecModelList[i].wholesalePrice) {
                  const wholesalePriceStr = String(val.goodSpecModelList[i].wholesalePrice);
                  val.goodSpecModelList[i].wholesalePrice = Number(wholesalePriceStr.replace(".", ""));
                }
              }
            });
        }
        if(err){
          this.$message.error(this.$t('merchandise', 'pleaseCompleteGoodsSpecification'))
          return
        }
        let arr = this.form.goodPhoto.map((item) => item.url);

        let data = {
          goodsName: this.form.goodsName, //商品名称
          stockNum: this.form.stockNum, //库存
          goodstypeId: this.form.goodstypeId, //类型ID
          goodsDetails: this.form.goodsDetails, //商品详情
          ispayment: this.form.ispayment, //支付方式
          isDistribution: this.form.isDistribution, //分销售
          isPublic: this.form.isPublic, //上架
          goodPhoto: arr.join(","), //商品图片
          goodsId: this.goodsId,
          isHiddenTitle:this.form.isHiddenTitle, //是否展示分销语
          coverImg:
            this.form.coverImg && this.form.coverImg.length != 0
              ? this.form.coverImg[0].url
              : [],
        };
        if (this.$route.query.id) {
          data.goodSpecRequestList = this.form.goodSpecModelList.map((row) => {
            return {
              specName: row.specName,
              specId: row.specId,
              requiredSelect : row.requiredSelect,
              list: row.goodSpecModelList.map((item) => {
                return {
                  specAttribute: item.specAttribute,
                  specNum: item.specNum,
                  price: item.price,
                  wholesalePrice: item.wholesalePrice,
                  specId: item.specId,
                };
              }),
            };
          });
        }
        
        const loading = this.$loading({
          lock: true,
          text: this.$t('merchandise', 'uploading'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        if (this.$route.query.id) {
          addGoods(data)
          .then(() => {
            loading.close();
            this.$message({
              message: this.$t('merchandise', 'operationSuccess'),
              type: "success",
              center: true,
            });
            this.$router.go(-1);
          })
          .catch(err=>{
            loading.close();
       
            if (this.form.goodSpecRequestList) {
              this.form.goodSpecRequestList.forEach((val, k) => {
                for (var i in val.list) {
                  if (val.list[i].price && typeof val.list[i].price === 'number') {
                    val.list[i].price = (val.list[i].price / 100).toFixed(2);
                  }
                  if (val.list[i].wholesalePrice && typeof val.list[i].wholesalePrice === 'number') {
                    val.list[i].wholesalePrice = (val.list[i].wholesalePrice / 100).toFixed(2);
                  }
                }
              });
            }
            this.$message({
              message: err.message || this.$t('merchandise', 'operationFailed'),
              type: "warning",
              center: true,
            });
          });
        } else {
          let val = JSON.parse(JSON.stringify(this.form))
          val.goodPhoto = arr.join(",")
          val.coverImg = this.form.coverImg[0].url
          addGoods(val).then(() => {
            loading.close();
            this.$message({
              message: this.$t('merchandise', 'operationSuccess'),
              type: "success",
              center: true,
            });
            this.$router.go(-1);
          })
          .catch(err=>{
            loading.close();
            if (this.form.goodSpecRequestList) {
              this.form.goodSpecRequestList.forEach((val, k) => {
                for (var i in val.list) {
                  if (val.list[i].price && typeof val.list[i].price === 'number') {
                    val.list[i].price = (val.list[i].price / 100).toFixed(2);
                  }
                  if (val.list[i].wholesalePrice && typeof val.list[i].wholesalePrice === 'number') {
                    val.list[i].wholesalePrice = (val.list[i].wholesalePrice / 100).toFixed(2);
                  }
                }
              });
            }
            this.$message({
              message: err.message || this.$t('merchandise', 'publishFailed'),
              type: "warning",
              center: true,
            });
          });
        }
      } else {
          console.log("error submit!!");
          this.$message.error(this.$t('common', 'pleaseCompleteFormInfo'));
          return false;
        }
      });
    },

    delAtt(index) {
      this.indexs = index;
    },

    //分享图片
    shareUpload(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: this.$t('merchandise', 'uploadSuccess'),
        type: "success",
      });
      let arr = [];
      fileList = fileList.map((item) => {
        if (item.response) {
          arr.push({
            url: `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${item.response.data}`,
            uid: item.uid,
          });
        } else {
          arr.push(item);
        }
      });
      this.form.coverImg = arr;
    },

    // //商品图片
    goodsUpload(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: this.$t('merchandise', 'uploadSuccess'),
        type: "success",
      });
      let arr = [];
      fileList = fileList.map((item) => {
        if (item.response) {
          arr.push({
            url: `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${item.response.data}`,
            uid: item.uid,
          });
        } else {
          arr.push(item);
        }
      });
      this.form.goodPhoto = arr;
      console.log(this.form.goodPhoto)
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    //新增分类弹窗
    open(row) {
      this.$prompt(this.$t('merchandise', 'pleaseEnterGoodsTypeName'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      })
        .then( async ({ value }) => {
          await addGoodsType({
            name: value,
            sort: 0,
            isDel: 0,
          });
          const datas = await getGoodsTypeInfo({}); //获取分类数据
          this.goodsType = datas.data;
          this.$message({
            type: "success",
            message: this.$t('merchandise', 'addSuccess'),
            center: true,
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t('merchandise', 'operationCancelled'),
            center: true,
          });
        });
    },
    prodClose() {
      this.isShow = false;
    },
    onEditorReady(quill) {
      // console.log('editor ready!', quill)
      let btnImg = document.querySelector('.ql-image')
      if (btnImg) {
        console.log(btnImg)
        btnImg.append('上传图片')
      }
    }
  },
};
</script>
<style lang="scss" scope>
.disabled .el-upload--picture-card {
  display: none;
}
.ql-image {
  width: auto !important;
}
</style>
